import withScroll from '../hoc/withScroll'
import onResize from '../utils/onResize'
import scrollManager from '../utils/scrollManager'
import customSelect from 'custom-select'

export default withScroll({
  name: 'header',

  previousScroll: 0,

  ui: {
    burger: '[js-header-burger]',
    mobilePanel: '[js-header-mobile-panel]',
    'subnav[]': '[js-header-subnav]',
    'toggleSubnav[]': '[js-header-toggle-subnav]',
    'back[]': '[js-header-back]',
  },

  events: [
    {
      on: 'click',
      target: 'burger',
      handle({ target }) {
        target.classList.toggle('is-active')
        this.ui.mobilePanel.classList.toggle('is-active')

        if (target.classList.contains('is-active')) {
          scrollManager.stop()
          this.el.classList.add('is-white')

          setTimeout(() => {
            this.el.classList.add('is-top-white')
          }, 400)
        } else {
          scrollManager.restart()
          this.el.classList.remove('is-white', 'is-top-white')

          const activeItem = document.querySelector('[js-header-toggle-subnav].is-active')

          setTimeout(() => {
            if (activeItem) {
              activeItem.classList.remove('is-active')
              activeItem.nextElementSibling.classList.remove('is-active')
            }
          }, 400)
        }
      },
    },
    {
      on: 'click',
      target: 'toggleSubnav',
      handle({ target }) {
        const activeItem = document.querySelector('[js-header-toggle-subnav].is-active')

        if (activeItem && activeItem !== target) {
          setTimeout(() => {
            activeItem.classList.remove('is-active')
            activeItem.nextElementSibling.classList.remove('is-active')
          }, 200)
        }

        target.classList.toggle('is-active')
        target.nextElementSibling.classList.toggle('is-active')

        if (target.classList.contains('is-active')) {
          scrollManager.stop()
          this.el.classList.add('is-white')
        } else {
          scrollManager.restart()
          if (!this.el.classList.contains('is-fixed')) {
            this.el.classList.remove('is-white')
          }
        }
      },
    },
    {
      on: 'click',
      target: 'back',
      handle({ target }) {
        const subnav = target.closest('[js-header-subnav]')
        subnav.classList.remove('is-active')
        subnav.previousElementSibling.classList.remove('is-active')
      },
    },
  ],

  componentDidMount() {
    this.off = onResize(this.onResize.bind(this))

    document.body.addEventListener('click', (e) => {
      if (!e.target.closest('[js-header-item]') && window.innerWidth >= 1280) {
        const activeItem = document.querySelector('[js-header-toggle-subnav].is-active')

        if (activeItem) {
          activeItem.classList.remove('is-active')
          activeItem.nextElementSibling.classList.remove('is-active')
          scrollManager.restart()

          if (!this.el.classList.contains('is-fixed')) {
            this.el.classList.remove('is-white')
          }
        }
      }
    })

    //  language switcher custom select
    document.querySelectorAll('.pll-switcher-select').forEach(select => {
      const customSelectEl = customSelect(select, {
        containerClass: 'custom-select-container',
        openerClass: 'custom-select-opener',
        panelClass: 'custom-select-panel',
        optionClass: 'custom-select-option',
        optgroupClass: 'custom-select-optgroup',
        isSelectedClass: 'is-selected',
        hasFocusClass: 'has-focus',
        isDisabledClass: 'is-disabled',
        isOpenClass: 'is-open',
      })

      const iconContainer = document.createElement('div')
      iconContainer.innerHTML = `
        <svg width="24" height="24" class="custom-select-icon">
          <use href="#icon-chevron-down" xlink:href="#icon-chevron-down"></use>
        </svg>
      `

      customSelectEl[0].container.appendChild(iconContainer.firstElementChild)
    })

    this.pageNav = document.querySelector(".page-nav")
  },

  componentWillUnmount() {
    this.off()
  },

  onResize() {
    this.headerHeight = this.el.offsetHeight
    const hero = document.querySelector('.hero-product') || document.querySelector('.hero-edito')
    if (hero) {
      this.heroOffsetBottom = hero.offsetTop + hero.offsetHeight
    } else {
      this.heroOffsetBottom = 0;
    }
  },

  onScroll({ y }) {
    if (y > this.headerHeight && (!this.pageNav || y < this.heroOffsetBottom - this.headerHeight)) {
      if (!this.el.classList.contains('is-fixed')) {
        this.el.classList.add('is-fixed', 'is-white')

        setTimeout(() => {
          this.el.classList.add('has-transition')
        }, 200)
      }

      if (Math.abs(y - this.previousScroll) >= 50) {
        let scriptsSliceInView = false
        let sliceScriptsElems = document.getElementsByClassName('slice-scripts')
        if (sliceScriptsElems.length > 0) {
          scriptsSliceInView = y > sliceScriptsElems[0].offsetTop && y < sliceScriptsElems[0].offsetTop + sliceScriptsElems[0].clientHeight
        }

        if (y < this.previousScroll && !scriptsSliceInView) {
          this.el.classList.add('is-visible')
        } else {
          this.el.classList.remove('is-visible')
        }
      }
    } else {
      if (y > this.previousScroll || y === 0) {
        this.el.classList.remove('is-visible', 'is-fixed', 'has-transition', 'is-white')
      }
    }

    this.previousScroll = y
  },
})
